import { clearAuthValidation } from "../../util/authValidation";

const INIT_STATE = {
   loading: false,
   alertMessage: "",
   showMessage: false,
   initURL: "",
   authUser: localStorage.getItem("userID"),
   backUrl: "",
   loggingIn: false,
   organization: null,
   company: null,
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SIGNUP_USER_SUCCESS": {
         return {
            ...state,
            loading: false,
            authUser: action.payload,
         };
      }
      case "SIGNIN_USER_SUCCESS": {
         return {
            ...state,
            authUser: action.payload,
         };
      }
      case "INIT_URL": {
         return {
            ...state,
            initURL: action.payload,
         };
      }
      case "SIGNOUT_USER_SUCCESS": {
         localStorage.removeItem("userID");
         return {
            ...state,
            authUser: null,
            initURL: "/",
            loading: false,
         };
      }

      case "SHOW_MESSAGE": {
         return {
            ...state,
            alertMessage: action.payload,
            showMessage: true,
            loading: false,
         };
      }
      case "HIDE_MESSAGE": {
         return {
            ...state,
            alertMessage: "",
            showMessage: false,
            loading: false,
         };
      }

      case "SIGNIN_GOOGLE_USER_SUCCESS": {
         return {
            ...state,
            loading: false,
            authUser: action.payload,
         };
      }
      case "SIGNIN_FACEBOOK_USER_SUCCESS": {
         return {
            ...state,
            loading: false,
            authUser: action.payload,
         };
      }
      case "SIGNIN_TWITTER_USER_SUCCESS": {
         return {
            ...state,
            loading: false,
            authUser: action.payload,
         };
      }
      case "SIGNIN_GITHUB_USER_SUCCESS": {
         return {
            ...state,
            loading: false,
            authUser: action.payload,
         };
      }
      case "ON_SHOW_LOADING": {
         return {
            ...state,
            loading: true,
         };
      }
      case "SET_LOGGING_IN": {
         if (action.payload) {
            clearAuthValidation();
         }

         return {
            ...state,
            loggingIn: action.payload,
         };
      }
      case "SET_ORGANIZATION": {
         return {
            ...state,
            organization: action.payload,
         };
      }
      case "SET_COMPANY": {
         return {
            ...state,
            currentCompany: action.payload,
         };
      }
      case "SET_CURRENT_DEPARTMENT": {
         return {
            ...state,
            currentDepartment: action.payload,
         };
      }
      case "ON_HIDE_LOADING": {
         return {
            ...state,
            loading: false,
         };
      }
      case "SET_BACK_URL": {
         return {
            ...state,
            backUrl: action.payload,
         };
      }

      default:
         return state;
   }
};
